import React from 'react'
import { Button, ButtonGroup, Col, Container, Image, Row } from 'react-bootstrap'
import Works from './Works'

const HomePage = () => {
  return (
    <Container>
      <Image src='./pic/icon.jpeg' roundedCircle width={300} className='mt-5 mb-5'></Image>
      <Row>
        <Col className='bg-light'>
          <h2 className='mt-3'>Tomoki Hosoya</h2>
          <Container className='text-left mt-3 mb-3'>
            東京大学大学院 農学生命科学研究科修士1年。
            <br />
            大学1年の時に受けたAIの授業がきっかけでエンジニアに興味を持ち始める。その後所属する組織の自動化・効率化に取り組むうちに自分のやりたいことを自分の力で実現できるエンジニア職の魅力にひかれ、エンジニア職を志す。
            <br />
            趣味は野球観戦・ゲーム・資格取得。</Container>
          <Button href="/about" variant='info' className='mt-1 mb-3'>自己紹介を見る</Button>
        </Col>
        <Col>
          <h2 className='mt-3 mb-3'>Contact</h2>
          <ButtonGroup size='lg' className='mb-5'>
            <Button variant='outline-info' href='mailto:xigu.tomo0420@gmail.com' target="_blank" rel="noopener noreferrer">e-mail</Button>
            <Button variant='outline-info' href='https://github.com/KojoBarbie' target="_blank" rel="noopener noreferrer">Github</Button>
            <Button variant='outline-info' href='https://qiita.com/KojoBarbie' target="_blank" rel="noopener noreferrer">Qiita</Button>
          </ButtonGroup>
          <br />
          <ButtonGroup size='lg' className='mb-5'>
            <Button variant='outline-info' href='https://atcoder.jp/users/KojoBarbie' target="_blank" rel="noopener noreferrer">Atcoder</Button>
            <Button variant='outline-info' href='https://www.kaggle.com/kojobarbie' target="_blank" rel="noopener noreferrer">Kaggle</Button>
          </ButtonGroup>
        </Col>
      </Row>
      <Works />
   </Container>
  )
}

export default HomePage